var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAuLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 363.67,
    height: 171.135,
    viewBox: "0 0 363.67 171.135",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1455",
    "data-name": "Group 1455",
    transform: "translate(-778.564 -1404.113)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1395",
    "data-name": "Group 1395"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_302",
    "data-name": "Path 302",
    d: "M1858.093,320.825h18l-9-21.432Z",
    transform: "translate(-1037.47 1172.232)",
    fill: "#e5600d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    "data-name": "Path 303",
    d: "M1926.763,272.269a85.567,85.567,0,1,0,85.563,85.565,85.565,85.565,0,0,0-85.562-85.565m-8.993,116.688c-3.34,0-5.57-1.949-6.87-4.921l-4.358-10.2h-28.577l-4.545,10.668a7.026,7.026,0,0,1-6.583,4.455,6.575,6.575,0,0,1-6.589-6.686,7.618,7.618,0,0,1,.834-3.059l22.636-51.118a8.823,8.823,0,0,1,8.351-5.663h.836c3.9,0,6.678,2.131,8.256,5.663l22.636,51.118a6.909,6.909,0,0,1,.747,2.877,6.777,6.777,0,0,1-6.773,6.867m68.465-28.859c0,19.671-11.042,29.319-28.482,29.319s-28.112-9.742-28.112-28.854V330.041a7.144,7.144,0,1,1,14.287,0v30.15c0,10.581,5.292,16.055,14.014,16.055s14.009-5.287,14.009-15.589V330.041a7.142,7.142,0,1,1,14.285,0Z",
    transform: "translate(-1062.632 1131.844)",
    fill: "#e5600d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    "data-name": "Path 304",
    d: "M1918.452,303.2l9.6-21.69a3.747,3.747,0,0,1,3.544-2.4h.356a3.694,3.694,0,0,1,3.5,2.4l9.6,21.69a2.934,2.934,0,0,1,.318,1.222,2.874,2.874,0,0,1-2.872,2.912,3.089,3.089,0,0,1-2.915-2.086l-1.85-4.331h-12.129l-1.927,4.528a2.977,2.977,0,0,1-2.792,1.889,2.791,2.791,0,0,1-2.8-2.835,3.216,3.216,0,0,1,.354-1.3m17.047-7.639-3.821-9.1-3.818,9.1Z",
    transform: "translate(-948.118 1142.025)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    d: "M1929.927,295.17V282.217a3.032,3.032,0,1,1,6.063,0v12.8c0,4.488,2.243,6.81,5.944,6.81s5.944-2.243,5.944-6.614V282.217a3.032,3.032,0,1,1,6.063,0v12.757c0,8.346-4.687,12.438-12.084,12.438s-11.93-4.132-11.93-12.241",
    transform: "translate(-930.504 1142.143)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    d: "M1919.226,318.494a2.837,2.837,0,0,1-1.143-2.285,2.791,2.791,0,0,1,2.835-2.8,2.929,2.929,0,0,1,1.732.55,11.609,11.609,0,0,0,7.047,2.484c2.481,0,3.978-.983,3.978-2.6v-.077c0-1.536-.946-2.322-5.553-3.5-5.548-1.416-9.132-2.952-9.132-8.426v-.077c0-5,4.018-8.309,9.645-8.309a16,16,0,0,1,8.739,2.444,2.747,2.747,0,0,1,1.339,2.4,2.79,2.79,0,0,1-2.832,2.8,2.916,2.916,0,0,1-1.536-.433,11.461,11.461,0,0,0-5.787-1.849c-2.325,0-3.544,1.063-3.544,2.4v.077c0,1.812,1.18,2.4,5.946,3.622,5.588,1.459,8.737,3.467,8.737,8.269v.08c0,5.471-4.172,8.54-10.116,8.54a17.788,17.788,0,0,1-10.354-3.306",
    transform: "translate(-948.139 1163.391)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    d: "M1928.253,296.583a3.009,3.009,0,0,1,3.031-3.034h.667a3.112,3.112,0,0,1,2.758,1.578l7.323,11.928,7.36-11.968a2.968,2.968,0,0,1,2.718-1.538h.667a3.009,3.009,0,0,1,3.032,3.034v21.889a3.011,3.011,0,1,1-6.021,0V304.73l-5.316,8.189a2.834,2.834,0,0,1-5.038,0l-5.237-8.07v13.7a2.959,2.959,0,0,1-2.992,2.957,2.923,2.923,0,0,1-2.952-2.957Z",
    transform: "translate(-932.996 1163.531)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    "data-name": "Path 308",
    d: "M1940.94,317.533l9.608-21.692a3.74,3.74,0,0,1,3.539-2.4h.356a3.7,3.7,0,0,1,3.5,2.4l9.605,21.692a2.957,2.957,0,0,1,.316,1.22,2.877,2.877,0,0,1-2.875,2.917,3.092,3.092,0,0,1-2.913-2.093l-1.852-4.326h-12.125l-1.929,4.525a2.984,2.984,0,0,1-2.795,1.894,2.791,2.791,0,0,1-2.793-2.84,3.24,3.24,0,0,1,.351-1.3m17.048-7.639-3.818-9.093-3.818,9.093Z",
    transform: "translate(-914.627 1163.367)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    d: "M1952.828,296.547a3.032,3.032,0,0,1,6.063,0V315.8h11.221a2.757,2.757,0,0,1,0,5.513H1955.86a3.009,3.009,0,0,1-3.032-3.032Z",
    transform: "translate(-896.402 1163.484)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_310",
    "data-name": "Path 310",
    d: "M1961.985,296.547a3.031,3.031,0,0,1,6.061,0V315.8h11.221a2.757,2.757,0,0,1,0,5.513h-14.25a3.007,3.007,0,0,1-3.032-3.032Z",
    transform: "translate(-882.767 1163.484)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    "data-name": "Path 311",
    d: "M1918.1,310.977a3.009,3.009,0,0,1,3.034-3.032h15.43a2.757,2.757,0,1,1,0,5.513h-12.4v5.862h10.628a2.757,2.757,0,1,1,0,5.513h-10.628v7.875a3.032,3.032,0,0,1-6.063,0Z",
    transform: "translate(-948.118 1184.969)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    "data-name": "Path 312",
    d: "M1927.951,310.878a3.032,3.032,0,0,1,6.063,0v21.971a3.032,3.032,0,0,1-6.063,0Z",
    transform: "translate(-933.445 1184.828)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    d: "M1932.521,310.96a3.011,3.011,0,0,1,3.032-3.034h.63a3.751,3.751,0,0,1,3.148,1.772l11.694,15.355V310.838a2.991,2.991,0,0,1,5.981,0v21.929a3.007,3.007,0,0,1-3.029,3.032h-.2a3.759,3.759,0,0,1-3.151-1.767l-12.122-15.908v14.763a2.993,2.993,0,0,1-5.986,0Z",
    transform: "translate(-926.641 1184.828)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_314",
    "data-name": "Path 314",
    d: "M1943.976,331.864l9.608-21.692a3.739,3.739,0,0,1,3.542-2.4h.354a3.7,3.7,0,0,1,3.5,2.4l9.6,21.692a2.949,2.949,0,0,1,.316,1.22,2.872,2.872,0,0,1-2.875,2.912,3.079,3.079,0,0,1-2.912-2.086l-1.852-4.329H1951.14l-1.929,4.525a2.969,2.969,0,0,1-2.793,1.889,2.788,2.788,0,0,1-2.795-2.83,3.2,3.2,0,0,1,.353-1.3m17.048-7.641-3.821-9.09-3.818,9.09Z",
    transform: "translate(-910.109 1184.711)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_315",
    "data-name": "Path 315",
    d: "M1955.863,310.96a3.01,3.01,0,0,1,3.029-3.034h.632a3.756,3.756,0,0,1,3.149,1.772l11.691,15.355V310.838a2.993,2.993,0,0,1,5.986,0v21.929a3.009,3.009,0,0,1-3.032,3.032h-.2a3.763,3.763,0,0,1-3.151-1.767l-12.125-15.908v14.763a2.992,2.992,0,1,1-5.983,0Z",
    transform: "translate(-891.883 1184.828)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_316",
    "data-name": "Path 316",
    d: "M1967.234,322.09v-.085a14.007,14.007,0,0,1,14.37-14.25,14.594,14.594,0,0,1,9.212,2.8,3.022,3.022,0,0,1,1.18,2.4A2.957,2.957,0,0,1,1989,315.9a3.18,3.18,0,0,1-1.812-.59,9.059,9.059,0,0,0-5.63-1.969c-4.642,0-7.99,3.858-7.99,8.582v.077c0,4.727,3.266,8.664,7.99,8.664a8.843,8.843,0,0,0,5.986-2.168,2.809,2.809,0,1,1,3.622,4.294,14.524,14.524,0,0,1-23.935-10.706",
    transform: "translate(-874.95 1184.686)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_317",
    "data-name": "Path 317",
    d: "M1978.761,332.47V310.979a3.01,3.01,0,0,1,3.034-3.034H1997.3a2.723,2.723,0,0,1,2.718,2.716,2.689,2.689,0,0,1-2.718,2.676H1984.79v5.593H1995.3a2.721,2.721,0,0,1,2.715,2.718,2.688,2.688,0,0,1-2.715,2.676H1984.79v5.787h12.478a2.721,2.721,0,0,1,2.718,2.716,2.69,2.69,0,0,1-2.718,2.676H1981.8a3.008,3.008,0,0,1-3.034-3.032",
    transform: "translate(-857.786 1184.969)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_318",
    "data-name": "Path 318",
    d: "M1918.1,325.392a3.009,3.009,0,0,1,3.034-3.032h9.762c3.148,0,5.628.866,7.2,2.442a6.321,6.321,0,0,1,1.889,4.684v.077a6.4,6.4,0,0,1-3.622,5.944c3.189,1.222,5.158,3.074,5.158,6.775v.077c0,5.038-4.095,7.557-10.312,7.557h-10.078a3.008,3.008,0,0,1-3.034-3.032Zm11.5,8.109c2.673,0,4.368-.866,4.368-2.915v-.077c0-1.812-1.419-2.833-3.978-2.833H1924V333.5Zm1.613,11.1c2.676,0,4.291-.941,4.291-2.989v-.075c0-1.852-1.381-3-4.49-3H1924V344.6Z",
    transform: "translate(-948.118 1206.434)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_319",
    "data-name": "Path 319",
    d: "M1928.479,346.2l9.605-21.692a3.75,3.75,0,0,1,3.542-2.4h.354a3.7,3.7,0,0,1,3.507,2.4l9.605,21.692a2.965,2.965,0,0,1,.316,1.217,2.878,2.878,0,0,1-2.875,2.917,3.091,3.091,0,0,1-2.915-2.086l-1.847-4.333h-12.126l-1.932,4.53a2.977,2.977,0,0,1-2.792,1.889,2.788,2.788,0,0,1-2.8-2.835,3.216,3.216,0,0,1,.354-1.3m17.047-7.639-3.818-9.09-3.821,9.09Z",
    transform: "translate(-933.187 1206.053)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_320",
    "data-name": "Path 320",
    d: "M1940.365,325.291a3.008,3.008,0,0,1,3.032-3.029h.63a3.754,3.754,0,0,1,3.148,1.772l11.694,15.353V325.174a2.992,2.992,0,0,1,5.984,0V347.1a3.012,3.012,0,0,1-3.032,3.034h-.2a3.764,3.764,0,0,1-3.151-1.772l-12.125-15.905v14.763a2.992,2.992,0,0,1-5.984,0Z",
    transform: "translate(-914.961 1206.168)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321",
    "data-name": "Path 321",
    d: "M1952.225,325.214a3.033,3.033,0,0,1,6.066,0v9.252l11.181-11.1a3.419,3.419,0,0,1,2.559-1.182,2.734,2.734,0,0,1,2.8,2.8,3.016,3.016,0,0,1-1.105,2.28l-7.756,7.246,8.465,10.628a3.225,3.225,0,0,1,.827,2.126,2.929,2.929,0,0,1-3.069,2.955,3.069,3.069,0,0,1-2.561-1.459l-7.871-10.315-3.465,3.228v5.513a3.033,3.033,0,0,1-6.066,0Z",
    transform: "translate(-897.3 1206.168)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuLogo);
export default __webpack_public_path__ + "static/media/au-logo.d8bb3d94ab719c9c60df9b84489f04ec.svg";
export { ForwardRef as ReactComponent };